import Vue from 'vue';
import App from './AppV2.vue';
import router from './router';
import store from './store';
import '@/utils/title.js';
import '@/utils/common.js'
Vue.config.productionTip = false;
// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper';
// require styles
import 'swiper/dist/css/swiper.css';

// 安装animate.css
import animated from 'animate.css'; // npm install animate.css --save安装，在引入
Vue.use(animated);
Vue.use(VueAwesomeSwiper);

import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: 'af134deb9fa385e7cbc8cea1a37870a1',
  plugin: [
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PlaceSearch',
    'AMap.Geolocation',
    'AMap.Geocoder'
  ],
  v: '1.4.4',
  uiVersion: '1.0'
});

import VueAreaLinkage from 'vue-area-linkage';
import 'vue-area-linkage/dist/index.css';

Vue.use(VueAreaLinkage);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
